import { Component, OnInit } from '@angular/core';
import { CompanyService } from 'src/app/company/company.service';
import { AppService } from '../../app.service'
import { Router } from '@angular/router';
import { Role } from 'src/app/shared/models/user-model';
import { selectPrfName } from 'src/app/store/selectors/app.selector';
import { Store } from '@ngrx/store';

@Component({
    selector: 'app-prioryearcomparison',
    templateUrl: './prioryearcomparison.component.html',
    styleUrls: ['./prioryearcomparison.component.scss'],
    standalone: false
})
export class PrioryearcomparisonComponent implements OnInit {

  prfYear: number;
  prfNumber: string;
  prfName: string;
  compno: any;
  groupCode: any;
  priorYearComparisonList: any[] = [];
  compareToPrfNumber: string;
  spinnergetprioryearcomparison: boolean = false;
  showPageError: boolean = false;
  pageError: string = "";
  disableComapreTo: boolean = false;
  isReadOnlyAdmin: boolean;
  isLocked: boolean;
  isReadOnly: boolean;
  flagNote: boolean = false;
  isCustomer: boolean = false;
  format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

  constructor(private readonly companyService: CompanyService,
              private readonly appService: AppService,
              private readonly router: Router,
              private readonly store: Store
            ) { }

  ngOnInit(): void {
    if (!this.appService.hasRole(Role.Admin)) {
      this.isCustomer = true;
    }
    this.compno = this.companyService.companyId;
    this.prfYear = this.companyService.currentYear;
    this.prfNumber = this.companyService.prfNumber;
    this.compareToPrfNumber = this.prfNumber;

    this.store.select(selectPrfName).subscribe(prfName => {
      this.prfName = prfName;
    });

    this.isLocked = this.companyService.isEditLocked;
    this.isReadOnlyAdmin = this.appService.isReadonlyAdmin;
    this.isReadOnly = this.isLocked || this.isReadOnlyAdmin;
    this.groupCode = this.companyService.groupCode;
    this.loadPriorYearComparison();
    this.getPrgress();
  }

  getPrgress() {
    this.companyService.getCustomerPrfProgress(this.prfYear, this.compno, this.groupCode).subscribe({
      next: (resp) => {
        if (resp["message"] == "Success") {
        }
      },
      error: (error) => {
        // //console.log(error);
        this.router.navigate(['/apifailure']);
      }
    });
  }

  loadPriorYearComparison() {
    this.spinnergetprioryearcomparison = true;
    this.priorYearComparisonList = [];
    this.companyService.loadPriorYearComparisonDetails(this.prfYear, this.groupCode, this.compno, this.compareToPrfNumber).subscribe({
      next: (response) => {
        this.spinnergetprioryearcomparison = false;
        if (response["message"] == "Success") {
          this.priorYearComparisonList = response['comparisondata']['prior_comparison_data'];
          if (this.priorYearComparisonList.length == 0) {
            this.pageError = response['comparisondata']['msg'];
            this.showPageError = true;
            return;
          }
          else {
            for (let i = 0; i < this.priorYearComparisonList.length; i++) {
              if (this.priorYearComparisonList[i]["mark"] != "")
                this.flagNote = true;
            }
            this.showPageError = false;
          }
           this.priorYearComparisonList = this.priorYearComparisonList.filter(item => !(parseFloat(item.priorpremium) === 0 && parseFloat(item.currpremium) === 0));
            if( this.priorYearComparisonList.length == 0) {
            this.showPageError = true;
            this.pageError = `No comparison data exist for company : ${this.compareToPrfNumber}`;
          }
        }
      },
      error: (error) => {
        this.spinnergetprioryearcomparison = false;
        this.router.navigate(['/apifailure']);
      }
    });
  }

  compareTo() {
    let value = this.compareToPrfNumber.toUpperCase();
    if ((this.compareToPrfNumber == "") || (value.length > 6) || ((value.length > 4) && !(value.substring(4).match(/^[a-zA-Z]+$/)))|| (value.length == 4 && !(/^\d+$/.test(value)) || (value.length < 4 && !(/^\d+$/.test(value)) )) || (value.length<4) || (this.format.test(value)) || (isNaN(+value.substring(0,4))) ) {
      this.pageError = "Invalid search criteria. Search with valid PRF Number"
      this.showPageError = true;
    }
    else {
      this.showPageError = false;
      this.loadPriorYearComparison();
    }
  }
  email() {
    let value = this.compareToPrfNumber.toUpperCase();
    if ((this.compareToPrfNumber == "") || (value.length > 6) || ((value.length > 4) && !(value.substring(4).match(/^[a-zA-Z]+$/)))|| (value.length == 4 && !(/^\d+$/.test(value)) || (value.length < 4 && !(/^\d+$/.test(value)) )) || (value.length<4) || (this.format.test(value)) || (isNaN(+value.substring(0,4))) ) {
      this.pageError = "Invalid search criteria. Search with valid PRF Number"
      this.showPageError = true;
    }
    else {
      this.showPageError = false;
      sessionStorage.setItem("routename", `/${this.prfYear}/${this.prfNumber}/prioryearcomparison`);
      sessionStorage.setItem("comparedprfnumber", this.compareToPrfNumber);
      this.router.navigate(['/emailpreview'])
    }
  }
}
